import { DecimalPipe, JsonPipe } from '@angular/common'
import { Component, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router'
import { DashboardHomeService } from 'src/app/core/dashboard/dashboard-home.service'
import { HorizontalMenuModule } from 'src/app/shared/components/horizontal-menu/horizontal-menu.module'

@Component({
    selector: 'sf-dashboard',
    imports: [RouterLink, RouterLinkActive, RouterOutlet, HorizontalMenuModule],
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
    dashboardService = inject(DashboardHomeService)

    dashboardStats = toSignal(this.dashboardService.getDashboardStats())
}
